import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: Date; output: Date; }
  JSON: { input: any; output: any; }
};

export type AcceptPrivacyPolicyInput = {
  isAccepted: Scalars['Boolean']['input'];
  policyId: Scalars['String']['input'];
};

export type AcceptPrivacyPolicyOutput = {
  __typename?: 'AcceptPrivacyPolicyOutput';
  userPrivacyPolicyAcceptance: UserPrivacyPolicyAcceptance;
};

export type AcceptTermAndConditionInput = {
  isAccepted: Scalars['Boolean']['input'];
  termAndConditionId: Scalars['String']['input'];
};

export type AcceptTermAndConditionOutput = {
  __typename?: 'AcceptTermAndConditionOutput';
  userTermAndConditionAcceptance: UserTermAndConditionAcceptance;
};

export type CheckUserAcceptanceForLatestPrivacyPolicyOutput = {
  __typename?: 'CheckUserAcceptanceForLatestPrivacyPolicyOutput';
  isAccepted: Scalars['Boolean']['output'];
  privacyPolicy: PrivacyPolicy;
};

export type CheckUserAcceptanceForLatestTermAndConditionOutput = {
  __typename?: 'CheckUserAcceptanceForLatestTermAndConditionOutput';
  isAccepted: Scalars['Boolean']['output'];
  termAndCondition: TermAndCondition;
};

export type CheckUserPrivacyPolicyAcceptanceInput = {
  policyId: Scalars['String']['input'];
};

export type CheckUserPrivacyPolicyAcceptanceOutput = {
  __typename?: 'CheckUserPrivacyPolicyAcceptanceOutput';
  isAccepted: Scalars['Boolean']['output'];
  privacyPolicy: Maybe<UserPrivacyPolicyAcceptance>;
};

export type CheckUserTermAndConditionAcceptanceInput = {
  termAndConditionId: Scalars['String']['input'];
};

export type CheckUserTermAndConditionAcceptanceOutput = {
  __typename?: 'CheckUserTermAndConditionAcceptanceOutput';
  isAccepted: Scalars['Boolean']['output'];
  termAndCondition: Maybe<UserTermAndConditionAcceptance>;
};

export type ClientUser = {
  __typename?: 'ClientUser';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  enabledAt: Maybe<Scalars['DateTime']['output']>;
  expiredAt: Scalars['DateTime']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idNumber: Scalars['String']['output'];
  idType: IdType;
  imageUrl: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  middleName: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  status: UserStratus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userPrivacyPolicies: Array<UserPrivacyPolicyAcceptance>;
  username: Scalars['String']['output'];
};

export type CreatePrivacyPolicyInput = {
  description: Scalars['String']['input'];
  documentUrl: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  version: Scalars['String']['input'];
};

export type CreatePrivacyPolicyOutput = {
  __typename?: 'CreatePrivacyPolicyOutput';
  privacyPolicy: PrivacyPolicy;
};

export type CreateTermAndConditionInput = {
  description: Scalars['String']['input'];
  documentUrl: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  version: Scalars['String']['input'];
};

export type CreateTermAndConditionOutput = {
  __typename?: 'CreateTermAndConditionOutput';
  termAndCondition: TermAndCondition;
};

/** DOPA verification status */
export enum DopaVerificationStatus {
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Success = 'SUCCESS',
  Unauthorized = 'UNAUTHORIZED',
  Unknown = 'UNKNOWN'
}

export type EKycDocument = {
  __typename?: 'EKycDocument';
  storageObject: KycStorageObject;
  type: EKycDocumentType;
};

/** e-KYC document type */
export enum EKycDocumentType {
  CitizenCardBack = 'CITIZEN_CARD_BACK',
  CitizenCardFront = 'CITIZEN_CARD_FRONT',
  FaceImage = 'FACE_IMAGE'
}

/** e-KYC verification status */
export enum EKycDocumentVerificationStatus {
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  NotStarted = 'NOT_STARTED',
  Rejected = 'REJECTED',
  Uploaded = 'UPLOADED',
  Verified = 'VERIFIED'
}

/** e-KYC ID type */
export enum EKycIdType {
  CitizenCard = 'CITIZEN_CARD',
  Passport = 'PASSPORT'
}

export type EKycInfo = {
  __typename?: 'EKycInfo';
  address: Maybe<Scalars['String']['output']>;
  backCardVerified: EKycDocumentVerificationStatus;
  cardVerified: EKycDocumentVerificationStatus;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth: Maybe<Scalars['DateTime']['output']>;
  documents: Array<EKycDocument>;
  email: Scalars['String']['output'];
  expiryDate: Maybe<Scalars['DateTime']['output']>;
  faceMatchSimilarity: Maybe<Scalars['Float']['output']>;
  faceMatched: EKycDocumentVerificationStatus;
  firstname: Maybe<Scalars['String']['output']>;
  firstnameEng: Maybe<Scalars['String']['output']>;
  frontCardVerified: EKycDocumentVerificationStatus;
  id: Scalars['ID']['output'];
  idCode: Maybe<Scalars['String']['output']>;
  idNumber: Maybe<Scalars['String']['output']>;
  idType: Maybe<EKycIdType>;
  issuedDate: Maybe<Scalars['DateTime']['output']>;
  lastname: Maybe<Scalars['String']['output']>;
  lastnameEng: Maybe<Scalars['String']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
  middleNameEng: Maybe<Scalars['String']['output']>;
  reasons: Maybe<Array<EKycInfoReason>>;
  status: EKycVerificationStatus;
  title: Maybe<Scalars['String']['output']>;
  titleEng: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  verificationCheckList: Maybe<EKycVerificationCheckListObjectType>;
  verifiedAt: Maybe<Scalars['DateTime']['output']>;
  verifiedBy: Maybe<Scalars['String']['output']>;
};

export type EKycInfoReason = {
  __typename?: 'EKycInfoReason';
  id: EKycInfoReasonId;
  isPassed: Scalars['Boolean']['output'];
};

/** e-KYC info reason ID */
export enum EKycInfoReasonId {
  ClearBackCardText = 'CLEAR_BACK_CARD_TEXT',
  ClearFaceImage = 'CLEAR_FACE_IMAGE',
  ClearFrontCardText = 'CLEAR_FRONT_CARD_TEXT',
  MatchedFaceImage = 'MATCHED_FACE_IMAGE',
  MatchedIdCardInfo = 'MATCHED_ID_CARD_INFO'
}

/** e-KYC upload content type */
export enum EKycUploadContentType {
  Gif = 'GIF',
  Jpeg = 'JPEG',
  Pdf = 'PDF',
  Png = 'PNG',
  Webp = 'WEBP'
}

export type EKycVerificationCheckListObjectType = {
  __typename?: 'EKycVerificationCheckListObjectType';
  idPhotoClarity: Scalars['Boolean']['output'];
  photoClarity: Scalars['Boolean']['output'];
  photoIdentityMatch: Scalars['Boolean']['output'];
};

/** e-KYC status */
export enum EKycVerificationStatus {
  Approved = 'APPROVED',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  NotRequired = 'NOT_REQUIRED',
  NotStarted = 'NOT_STARTED',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED',
  Terminated = 'TERMINATED'
}

export enum ExamEventExamineeResultCertificateType {
  SocialMedia = 'SOCIAL_MEDIA',
  Unofficial = 'UNOFFICIAL'
}

export type FinishKycVerificationInput = {
  userId: Scalars['String']['input'];
};

export type GetAllPrivacyPoliciesInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetAllPrivacyPoliciesOutput = {
  __typename?: 'GetAllPrivacyPoliciesOutput';
  privacyPolicies: Array<PrivacyPolicy>;
};

export type GetAllTermAndConditionsInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetAllTermAndConditionsOutput = {
  __typename?: 'GetAllTermAndConditionsOutput';
  termAndConditions: Array<TermAndCondition>;
};

export type GetEKycUploadSignedUrlOutput = {
  __typename?: 'GetEKycUploadSignedUrlOutput';
  signedUrl: Scalars['String']['output'];
  storageObject: StorageObject;
};

export type GetKycInfoByUserIdInput = {
  userId: Scalars['String']['input'];
};

export type GetLatestActivePrivacyPolicyOutput = {
  __typename?: 'GetLatestActivePrivacyPolicyOutput';
  privacyPolicy: PrivacyPolicy;
};

export type GetLatestActiveTermAndConditionOutput = {
  __typename?: 'GetLatestActiveTermAndConditionOutput';
  termAndCondition: TermAndCondition;
};

export type GetPrivacyPolicyByIdOutput = {
  __typename?: 'GetPrivacyPolicyByIdOutput';
  privacyPolicy: PrivacyPolicy;
};

export type GetPrivacyPolicyByUdInput = {
  id: Scalars['String']['input'];
};

export type GetPublicCertificateByExamEventExamineeIdInput = {
  examEventExamineeId: Scalars['String']['input'];
  type: ExamEventExamineeResultCertificateType;
};

export type GetPublicCertificateByExamEventExamineeIdOutput = {
  __typename?: 'GetPublicCertificateByExamEventExamineeIdOutput';
  publicCertificateUrl: Scalars['String']['output'];
};

export type GetPublicCertificateByIdInput = {
  id: Scalars['String']['input'];
};

export type GetPublicCertificateByIdOutput = {
  __typename?: 'GetPublicCertificateByIdOutput';
  publicCertificateUrl: Scalars['String']['output'];
};

export type GetTermAndConditionByIdInput = {
  id: Scalars['String']['input'];
};

export type GetTermAndConditionByIdOutput = {
  __typename?: 'GetTermAndConditionByIdOutput';
  termAndCondition: TermAndCondition;
};

export type GetUploadSignedUrlInput = {
  contentType: EKycUploadContentType;
  userId: Scalars['String']['input'];
};

export type GetUserByTokenInput = {
  token: Scalars['String']['input'];
};

export type GetUserByTokenOutput = {
  __typename?: 'GetUserByTokenOutput';
  user: ClientUser;
};

export type GetUserImageDownloadSignedUrlOutput = {
  __typename?: 'GetUserImageDownloadSignedUrlOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetUserPrivacyPoliciesInput = {
  acceptOption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetUserPrivacyPoliciesOutput = {
  __typename?: 'GetUserPrivacyPoliciesOutput';
  userPrivacyPolicyAcceptances: Array<UserPrivacyPolicyAcceptance>;
};

export type GetUserTermAndConditionAcceptancesInput = {
  acceptOption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetUserTermAndConditionAcceptancesOutput = {
  __typename?: 'GetUserTermAndConditionAcceptancesOutput';
  userTermAndConditionAcceptances: Array<UserTermAndConditionAcceptance>;
};

export enum IdType {
  CitizenCard = 'CITIZEN_CARD',
  Passport = 'PASSPORT'
}

export type KycStorageObject = {
  __typename?: 'KYCStorageObject';
  bucket: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  type: StorageObjectProvider;
};

export type Mutation = {
  __typename?: 'Mutation';
  cluAcceptPrivacyPolicy: AcceptPrivacyPolicyOutput;
  cluAcceptTermAndCondition: AcceptTermAndConditionOutput;
  cluCreatePrivacyPolicy: CreatePrivacyPolicyOutput;
  cluCreateTermAndCondition: CreateTermAndConditionOutput;
  cluUpdatePrivacyPolicy: UpdatePrivacyPolicyOutput;
  cluUpdateTermAndCondition: UpdateTermAndConditionOutput;
  kycFinishKycVerification: EKycInfo;
  kycReadCitizenCardBack: EKycInfo;
  kycReadCitizenCardFront: EKycInfo;
  kycUpdateKycInfo: EKycInfo;
  kycVerifyCitizenCard: VerifyCitizenCardOutput;
  kycVerifyFaceSimilarity: EKycInfo;
};


export type MutationCluAcceptPrivacyPolicyArgs = {
  AcceptPrivacyPolicyInput: AcceptPrivacyPolicyInput;
};


export type MutationCluAcceptTermAndConditionArgs = {
  AcceptTermAndConditionInput: AcceptTermAndConditionInput;
};


export type MutationCluCreatePrivacyPolicyArgs = {
  CreatePrivacyPolicyInput: CreatePrivacyPolicyInput;
};


export type MutationCluCreateTermAndConditionArgs = {
  CreateTermAndConditionInput: CreateTermAndConditionInput;
};


export type MutationCluUpdatePrivacyPolicyArgs = {
  UpdatePrivacyPolicyInput: UpdatePrivacyPolicyInput;
};


export type MutationCluUpdateTermAndConditionArgs = {
  UpdateTermAndConditionInput: UpdateTermAndConditionInput;
};


export type MutationKycFinishKycVerificationArgs = {
  FinishKycVerificationInput: FinishKycVerificationInput;
};


export type MutationKycReadCitizenCardBackArgs = {
  ReadCitizenCardInput: ReadCitizenCardInput;
};


export type MutationKycReadCitizenCardFrontArgs = {
  ReadCitizenCardInput: ReadCitizenCardInput;
};


export type MutationKycUpdateKycInfoArgs = {
  UpdateKycInfoInput: UpdateKycInfoInput;
};


export type MutationKycVerifyCitizenCardArgs = {
  VerifyCitizenCardInput: VerifyCitizenCardInput;
};


export type MutationKycVerifyFaceSimilarityArgs = {
  VerifyFaceSimilarityInput: VerifyFaceSimilarityInput;
};

export type PrivacyPolicy = {
  __typename?: 'PrivacyPolicy';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  documentUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  certGetPublicCertificateByExamEventExamineeId: GetPublicCertificateByExamEventExamineeIdOutput;
  certGetPublicCertificateById: GetPublicCertificateByIdOutput;
  cluCheckUserAcceptanceForLatestPrivacyPolicy: CheckUserAcceptanceForLatestPrivacyPolicyOutput;
  cluCheckUserAcceptanceForLatestTermAndCondition: CheckUserAcceptanceForLatestTermAndConditionOutput;
  cluCheckUserPrivacyPolicyAcceptance: CheckUserPrivacyPolicyAcceptanceOutput;
  cluCheckUserTermAndConditionAcceptance: CheckUserTermAndConditionAcceptanceOutput;
  cluGetAllPrivacyPolicies: GetAllPrivacyPoliciesOutput;
  cluGetAllTermAndConditions: GetAllTermAndConditionsOutput;
  cluGetLatestActivePrivacyPolicy: GetLatestActivePrivacyPolicyOutput;
  cluGetLatestActiveTermAndCondition: GetLatestActiveTermAndConditionOutput;
  cluGetMyProfile: ClientUser;
  cluGetPrivacyPolicyById: GetPrivacyPolicyByIdOutput;
  cluGetTermAndConditionById: GetTermAndConditionByIdOutput;
  cluGetUserByToken: GetUserByTokenOutput;
  cluGetUserImageDownloadSignedUrl: GetUserImageDownloadSignedUrlOutput;
  cluGetUserPrivacyPolicies: GetUserPrivacyPoliciesOutput;
  cluGetUserTermAndConditionAcceptances: GetUserTermAndConditionAcceptancesOutput;
  kycGetKycInfoByUserId: EKycInfo;
  kycGetTemporaryFolderUploadSignedUrl: GetEKycUploadSignedUrlOutput;
  kycGetUploadSignedUrl: GetEKycUploadSignedUrlOutput;
};


export type QueryCertGetPublicCertificateByExamEventExamineeIdArgs = {
  getPublicCertificateByExamEventExamineeIdInput: GetPublicCertificateByExamEventExamineeIdInput;
};


export type QueryCertGetPublicCertificateByIdArgs = {
  input: GetPublicCertificateByIdInput;
};


export type QueryCluCheckUserPrivacyPolicyAcceptanceArgs = {
  CheckUserPrivacyPolicyInput: CheckUserPrivacyPolicyAcceptanceInput;
};


export type QueryCluCheckUserTermAndConditionAcceptanceArgs = {
  CheckUserTermAndConditionAcceptanceInput: CheckUserTermAndConditionAcceptanceInput;
};


export type QueryCluGetAllPrivacyPoliciesArgs = {
  GetAllPrivacyPoliciesInput: GetAllPrivacyPoliciesInput;
};


export type QueryCluGetAllTermAndConditionsArgs = {
  GetAllTermAndConditionsInput: GetAllTermAndConditionsInput;
};


export type QueryCluGetPrivacyPolicyByIdArgs = {
  GetPrivacyPolicyByIdInput: GetPrivacyPolicyByUdInput;
};


export type QueryCluGetTermAndConditionByIdArgs = {
  GetTermAndConditionByIdInput: GetTermAndConditionByIdInput;
};


export type QueryCluGetUserByTokenArgs = {
  GetUserByTokenInput: GetUserByTokenInput;
};


export type QueryCluGetUserPrivacyPoliciesArgs = {
  GetUserPrivacyPoliciesInput: GetUserPrivacyPoliciesInput;
};


export type QueryCluGetUserTermAndConditionAcceptancesArgs = {
  GetUserTermAndConditionAcceptancesInput: GetUserTermAndConditionAcceptancesInput;
};


export type QueryKycGetKycInfoByUserIdArgs = {
  GetKycInfoByUserIdInput: GetKycInfoByUserIdInput;
};


export type QueryKycGetTemporaryFolderUploadSignedUrlArgs = {
  GetUploadSignedUrlInput: GetUploadSignedUrlInput;
};


export type QueryKycGetUploadSignedUrlArgs = {
  GetUploadSignedUrlInput: GetUploadSignedUrlInput;
};

export type ReadCitizenCardInput = {
  temporaryCardImageFileName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  watermarkedCardImageFileName: Scalars['String']['input'];
};

export type StorageObject = {
  __typename?: 'StorageObject';
  bucket: Scalars['String']['output'];
  fileName: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  provider: StorageProvider;
};

/** Storage object provider */
export enum StorageObjectProvider {
  Gcs = 'GCS'
}

export enum StorageProvider {
  GcloudStorage = 'GCLOUD_STORAGE'
}

export type TermAndCondition = {
  __typename?: 'TermAndCondition';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  documentUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type UpdateKycInfoInput = {
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  idCode?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdatePrivacyPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePrivacyPolicyOutput = {
  __typename?: 'UpdatePrivacyPolicyOutput';
  privacyPolicy: PrivacyPolicy;
};

export type UpdateTermAndConditionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTermAndConditionOutput = {
  __typename?: 'UpdateTermAndConditionOutput';
  termAndCondition: TermAndCondition;
};

export type UserPrivacyPolicyAcceptance = {
  __typename?: 'UserPrivacyPolicyAcceptance';
  acceptedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isAccepted: Scalars['Boolean']['output'];
  policyId: Scalars['String']['output'];
  privacyPolicy: PrivacyPolicy;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export enum UserStratus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Revoked = 'REVOKED'
}

export type UserTermAndConditionAcceptance = {
  __typename?: 'UserTermAndConditionAcceptance';
  acceptedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isAccepted: Scalars['Boolean']['output'];
  termAndCondition: TermAndCondition;
  termAndConditionId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type VerifyCitizenCardInput = {
  userId: Scalars['String']['input'];
};

export type VerifyCitizenCardOutput = {
  __typename?: 'VerifyCitizenCardOutput';
  dopaVerificationStatus: DopaVerificationStatus;
  eKycInfo: EKycInfo;
  message: Scalars['String']['output'];
};

export type VerifyFaceSimilarityInput = {
  temporaryFaceImageFileName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  watermarkedFaceImageFileName: Scalars['String']['input'];
};

export type KycReadCitizenCardBackMutationVariables = Exact<{
  readCitizenCardInput: ReadCitizenCardInput;
}>;


export type KycReadCitizenCardBackMutation = { __typename?: 'Mutation', kycReadCitizenCardBack: { __typename?: 'EKycInfo', id: string, userId: string, status: EKycVerificationStatus, comment: string | null, verifiedAt: Date | null, verifiedBy: string | null, title: string | null, firstname: string | null, middleName: string | null, lastname: string | null, idType: EKycIdType | null, idNumber: string | null, idCode: string | null, dateOfBirth: Date | null, issuedDate: Date | null, expiryDate: Date | null, address: string | null, createdAt: Date, updatedAt: Date, faceMatchSimilarity: number | null, frontCardVerified: EKycDocumentVerificationStatus, backCardVerified: EKycDocumentVerificationStatus, cardVerified: EKycDocumentVerificationStatus, faceMatched: EKycDocumentVerificationStatus, documents: Array<{ __typename?: 'EKycDocument', type: EKycDocumentType, storageObject: { __typename?: 'KYCStorageObject', type: StorageObjectProvider, key: string | null, bucket: string | null } }>, reasons: Array<{ __typename?: 'EKycInfoReason', id: EKycInfoReasonId, isPassed: boolean }> | null } };

export type KycReadCitizenCardFrontMutationVariables = Exact<{
  readCitizenCardInput: ReadCitizenCardInput;
}>;


export type KycReadCitizenCardFrontMutation = { __typename?: 'Mutation', kycReadCitizenCardFront: { __typename?: 'EKycInfo', id: string, userId: string, status: EKycVerificationStatus, comment: string | null, verifiedAt: Date | null, verifiedBy: string | null, title: string | null, firstname: string | null, middleName: string | null, lastname: string | null, idType: EKycIdType | null, idNumber: string | null, idCode: string | null, dateOfBirth: Date | null, issuedDate: Date | null, expiryDate: Date | null, address: string | null, createdAt: Date, updatedAt: Date, faceMatchSimilarity: number | null, frontCardVerified: EKycDocumentVerificationStatus, backCardVerified: EKycDocumentVerificationStatus, cardVerified: EKycDocumentVerificationStatus, faceMatched: EKycDocumentVerificationStatus, documents: Array<{ __typename?: 'EKycDocument', type: EKycDocumentType, storageObject: { __typename?: 'KYCStorageObject', type: StorageObjectProvider, key: string | null, bucket: string | null } }>, reasons: Array<{ __typename?: 'EKycInfoReason', id: EKycInfoReasonId, isPassed: boolean }> | null } };

export type KycVerifyFaceSimilarityMutationVariables = Exact<{
  verifyFaceSimilarityInput: VerifyFaceSimilarityInput;
}>;


export type KycVerifyFaceSimilarityMutation = { __typename?: 'Mutation', kycVerifyFaceSimilarity: { __typename?: 'EKycInfo', faceMatchSimilarity: number | null, faceMatched: EKycDocumentVerificationStatus } };

export type KycUpdateKycInfoMutationVariables = Exact<{
  updateKycInfoInput: UpdateKycInfoInput;
}>;


export type KycUpdateKycInfoMutation = { __typename?: 'Mutation', kycUpdateKycInfo: { __typename?: 'EKycInfo', id: string, userId: string, status: EKycVerificationStatus, title: string | null, firstname: string | null, lastname: string | null, titleEng: string | null, firstnameEng: string | null, lastnameEng: string | null, idType: EKycIdType | null, idNumber: string | null, idCode: string | null, dateOfBirth: Date | null, issuedDate: Date | null, expiryDate: Date | null, address: string | null, createdAt: Date, updatedAt: Date } };

export type KycVerifyCitizenCardMutationVariables = Exact<{
  verifyCitizenCardInput: VerifyCitizenCardInput;
}>;


export type KycVerifyCitizenCardMutation = { __typename?: 'Mutation', kycVerifyCitizenCard: { __typename?: 'VerifyCitizenCardOutput', dopaVerificationStatus: DopaVerificationStatus, message: string } };

export type KycFinishKycVerificationMutationVariables = Exact<{
  finishKycVerificationInput: FinishKycVerificationInput;
}>;


export type KycFinishKycVerificationMutation = { __typename?: 'Mutation', kycFinishKycVerification: { __typename?: 'EKycInfo', id: string } };

export type KycGetUploadSignedUrlQueryVariables = Exact<{
  kycGetUploadSignedUrlGetUploadSignedUrlInput: GetUploadSignedUrlInput;
}>;


export type KycGetUploadSignedUrlQuery = { __typename?: 'Query', kycGetUploadSignedUrl: { __typename?: 'GetEKycUploadSignedUrlOutput', signedUrl: string, storageObject: { __typename?: 'StorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null } } };

export type KycGetTemporaryFolderUploadSignedUrlQueryVariables = Exact<{
  getTemporaryFolderUploadSignedUrlInput: GetUploadSignedUrlInput;
}>;


export type KycGetTemporaryFolderUploadSignedUrlQuery = { __typename?: 'Query', kycGetTemporaryFolderUploadSignedUrl: { __typename?: 'GetEKycUploadSignedUrlOutput', signedUrl: string, storageObject: { __typename?: 'StorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null } } };

export type KycGetKycInfoByUserIdQueryVariables = Exact<{
  getKycInfoByUserIdInput: GetKycInfoByUserIdInput;
}>;


export type KycGetKycInfoByUserIdQuery = { __typename?: 'Query', kycGetKycInfoByUserId: { __typename?: 'EKycInfo', idNumber: string | null, idType: EKycIdType | null, userId: string, email: string, status: EKycVerificationStatus } };

export type CluGetUserByTokenQueryVariables = Exact<{
  getUserByTokenInput: GetUserByTokenInput;
}>;


export type CluGetUserByTokenQuery = { __typename?: 'Query', cluGetUserByToken: { __typename?: 'GetUserByTokenOutput', user: { __typename?: 'ClientUser', id: string } } };


export const KycReadCitizenCardBackDocument = gql`
    mutation KycReadCitizenCardBack($readCitizenCardInput: ReadCitizenCardInput!) {
  kycReadCitizenCardBack(ReadCitizenCardInput: $readCitizenCardInput) {
    id
    userId
    status
    documents {
      type
      storageObject {
        type
        key
        bucket
      }
    }
    reasons {
      id
      isPassed
    }
    comment
    verifiedAt
    verifiedBy
    title
    firstname
    middleName
    lastname
    idType
    idNumber
    idCode
    dateOfBirth
    issuedDate
    expiryDate
    address
    createdAt
    updatedAt
    faceMatchSimilarity
    frontCardVerified
    backCardVerified
    cardVerified
    faceMatched
  }
}
    `;
export type KycReadCitizenCardBackMutationFn = Apollo.MutationFunction<KycReadCitizenCardBackMutation, KycReadCitizenCardBackMutationVariables>;

/**
 * __useKycReadCitizenCardBackMutation__
 *
 * To run a mutation, you first call `useKycReadCitizenCardBackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKycReadCitizenCardBackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kycReadCitizenCardBackMutation, { data, loading, error }] = useKycReadCitizenCardBackMutation({
 *   variables: {
 *      readCitizenCardInput: // value for 'readCitizenCardInput'
 *   },
 * });
 */
export function useKycReadCitizenCardBackMutation(baseOptions?: Apollo.MutationHookOptions<KycReadCitizenCardBackMutation, KycReadCitizenCardBackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KycReadCitizenCardBackMutation, KycReadCitizenCardBackMutationVariables>(KycReadCitizenCardBackDocument, options);
      }
export type KycReadCitizenCardBackMutationHookResult = ReturnType<typeof useKycReadCitizenCardBackMutation>;
export type KycReadCitizenCardBackMutationResult = Apollo.MutationResult<KycReadCitizenCardBackMutation>;
export type KycReadCitizenCardBackMutationOptions = Apollo.BaseMutationOptions<KycReadCitizenCardBackMutation, KycReadCitizenCardBackMutationVariables>;
export const KycReadCitizenCardFrontDocument = gql`
    mutation KycReadCitizenCardFront($readCitizenCardInput: ReadCitizenCardInput!) {
  kycReadCitizenCardFront(ReadCitizenCardInput: $readCitizenCardInput) {
    id
    userId
    status
    documents {
      type
      storageObject {
        type
        key
        bucket
      }
    }
    reasons {
      id
      isPassed
    }
    comment
    verifiedAt
    verifiedBy
    title
    firstname
    middleName
    lastname
    idType
    idNumber
    idCode
    dateOfBirth
    issuedDate
    expiryDate
    address
    createdAt
    updatedAt
    faceMatchSimilarity
    frontCardVerified
    backCardVerified
    cardVerified
    faceMatched
  }
}
    `;
export type KycReadCitizenCardFrontMutationFn = Apollo.MutationFunction<KycReadCitizenCardFrontMutation, KycReadCitizenCardFrontMutationVariables>;

/**
 * __useKycReadCitizenCardFrontMutation__
 *
 * To run a mutation, you first call `useKycReadCitizenCardFrontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKycReadCitizenCardFrontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kycReadCitizenCardFrontMutation, { data, loading, error }] = useKycReadCitizenCardFrontMutation({
 *   variables: {
 *      readCitizenCardInput: // value for 'readCitizenCardInput'
 *   },
 * });
 */
export function useKycReadCitizenCardFrontMutation(baseOptions?: Apollo.MutationHookOptions<KycReadCitizenCardFrontMutation, KycReadCitizenCardFrontMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KycReadCitizenCardFrontMutation, KycReadCitizenCardFrontMutationVariables>(KycReadCitizenCardFrontDocument, options);
      }
export type KycReadCitizenCardFrontMutationHookResult = ReturnType<typeof useKycReadCitizenCardFrontMutation>;
export type KycReadCitizenCardFrontMutationResult = Apollo.MutationResult<KycReadCitizenCardFrontMutation>;
export type KycReadCitizenCardFrontMutationOptions = Apollo.BaseMutationOptions<KycReadCitizenCardFrontMutation, KycReadCitizenCardFrontMutationVariables>;
export const KycVerifyFaceSimilarityDocument = gql`
    mutation KycVerifyFaceSimilarity($verifyFaceSimilarityInput: VerifyFaceSimilarityInput!) {
  kycVerifyFaceSimilarity(VerifyFaceSimilarityInput: $verifyFaceSimilarityInput) {
    faceMatchSimilarity
    faceMatched
  }
}
    `;
export type KycVerifyFaceSimilarityMutationFn = Apollo.MutationFunction<KycVerifyFaceSimilarityMutation, KycVerifyFaceSimilarityMutationVariables>;

/**
 * __useKycVerifyFaceSimilarityMutation__
 *
 * To run a mutation, you first call `useKycVerifyFaceSimilarityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKycVerifyFaceSimilarityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kycVerifyFaceSimilarityMutation, { data, loading, error }] = useKycVerifyFaceSimilarityMutation({
 *   variables: {
 *      verifyFaceSimilarityInput: // value for 'verifyFaceSimilarityInput'
 *   },
 * });
 */
export function useKycVerifyFaceSimilarityMutation(baseOptions?: Apollo.MutationHookOptions<KycVerifyFaceSimilarityMutation, KycVerifyFaceSimilarityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KycVerifyFaceSimilarityMutation, KycVerifyFaceSimilarityMutationVariables>(KycVerifyFaceSimilarityDocument, options);
      }
export type KycVerifyFaceSimilarityMutationHookResult = ReturnType<typeof useKycVerifyFaceSimilarityMutation>;
export type KycVerifyFaceSimilarityMutationResult = Apollo.MutationResult<KycVerifyFaceSimilarityMutation>;
export type KycVerifyFaceSimilarityMutationOptions = Apollo.BaseMutationOptions<KycVerifyFaceSimilarityMutation, KycVerifyFaceSimilarityMutationVariables>;
export const KycUpdateKycInfoDocument = gql`
    mutation KycUpdateKycInfo($updateKycInfoInput: UpdateKycInfoInput!) {
  kycUpdateKycInfo(UpdateKycInfoInput: $updateKycInfoInput) {
    id
    userId
    status
    title
    firstname
    lastname
    titleEng
    firstnameEng
    lastnameEng
    idType
    idNumber
    idCode
    dateOfBirth
    issuedDate
    expiryDate
    address
    createdAt
    updatedAt
  }
}
    `;
export type KycUpdateKycInfoMutationFn = Apollo.MutationFunction<KycUpdateKycInfoMutation, KycUpdateKycInfoMutationVariables>;

/**
 * __useKycUpdateKycInfoMutation__
 *
 * To run a mutation, you first call `useKycUpdateKycInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKycUpdateKycInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kycUpdateKycInfoMutation, { data, loading, error }] = useKycUpdateKycInfoMutation({
 *   variables: {
 *      updateKycInfoInput: // value for 'updateKycInfoInput'
 *   },
 * });
 */
export function useKycUpdateKycInfoMutation(baseOptions?: Apollo.MutationHookOptions<KycUpdateKycInfoMutation, KycUpdateKycInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KycUpdateKycInfoMutation, KycUpdateKycInfoMutationVariables>(KycUpdateKycInfoDocument, options);
      }
export type KycUpdateKycInfoMutationHookResult = ReturnType<typeof useKycUpdateKycInfoMutation>;
export type KycUpdateKycInfoMutationResult = Apollo.MutationResult<KycUpdateKycInfoMutation>;
export type KycUpdateKycInfoMutationOptions = Apollo.BaseMutationOptions<KycUpdateKycInfoMutation, KycUpdateKycInfoMutationVariables>;
export const KycVerifyCitizenCardDocument = gql`
    mutation KycVerifyCitizenCard($verifyCitizenCardInput: VerifyCitizenCardInput!) {
  kycVerifyCitizenCard(VerifyCitizenCardInput: $verifyCitizenCardInput) {
    dopaVerificationStatus
    message
  }
}
    `;
export type KycVerifyCitizenCardMutationFn = Apollo.MutationFunction<KycVerifyCitizenCardMutation, KycVerifyCitizenCardMutationVariables>;

/**
 * __useKycVerifyCitizenCardMutation__
 *
 * To run a mutation, you first call `useKycVerifyCitizenCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKycVerifyCitizenCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kycVerifyCitizenCardMutation, { data, loading, error }] = useKycVerifyCitizenCardMutation({
 *   variables: {
 *      verifyCitizenCardInput: // value for 'verifyCitizenCardInput'
 *   },
 * });
 */
export function useKycVerifyCitizenCardMutation(baseOptions?: Apollo.MutationHookOptions<KycVerifyCitizenCardMutation, KycVerifyCitizenCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KycVerifyCitizenCardMutation, KycVerifyCitizenCardMutationVariables>(KycVerifyCitizenCardDocument, options);
      }
export type KycVerifyCitizenCardMutationHookResult = ReturnType<typeof useKycVerifyCitizenCardMutation>;
export type KycVerifyCitizenCardMutationResult = Apollo.MutationResult<KycVerifyCitizenCardMutation>;
export type KycVerifyCitizenCardMutationOptions = Apollo.BaseMutationOptions<KycVerifyCitizenCardMutation, KycVerifyCitizenCardMutationVariables>;
export const KycFinishKycVerificationDocument = gql`
    mutation kycFinishKycVerification($finishKycVerificationInput: FinishKycVerificationInput!) {
  kycFinishKycVerification(
    FinishKycVerificationInput: $finishKycVerificationInput
  ) {
    id
  }
}
    `;
export type KycFinishKycVerificationMutationFn = Apollo.MutationFunction<KycFinishKycVerificationMutation, KycFinishKycVerificationMutationVariables>;

/**
 * __useKycFinishKycVerificationMutation__
 *
 * To run a mutation, you first call `useKycFinishKycVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKycFinishKycVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kycFinishKycVerificationMutation, { data, loading, error }] = useKycFinishKycVerificationMutation({
 *   variables: {
 *      finishKycVerificationInput: // value for 'finishKycVerificationInput'
 *   },
 * });
 */
export function useKycFinishKycVerificationMutation(baseOptions?: Apollo.MutationHookOptions<KycFinishKycVerificationMutation, KycFinishKycVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KycFinishKycVerificationMutation, KycFinishKycVerificationMutationVariables>(KycFinishKycVerificationDocument, options);
      }
export type KycFinishKycVerificationMutationHookResult = ReturnType<typeof useKycFinishKycVerificationMutation>;
export type KycFinishKycVerificationMutationResult = Apollo.MutationResult<KycFinishKycVerificationMutation>;
export type KycFinishKycVerificationMutationOptions = Apollo.BaseMutationOptions<KycFinishKycVerificationMutation, KycFinishKycVerificationMutationVariables>;
export const KycGetUploadSignedUrlDocument = gql`
    query KycGetUploadSignedUrl($kycGetUploadSignedUrlGetUploadSignedUrlInput: GetUploadSignedUrlInput!) {
  kycGetUploadSignedUrl(
    GetUploadSignedUrlInput: $kycGetUploadSignedUrlGetUploadSignedUrlInput
  ) {
    signedUrl
    storageObject {
      provider
      bucket
      key
      fileName
    }
  }
}
    `;

/**
 * __useKycGetUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useKycGetUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useKycGetUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKycGetUploadSignedUrlQuery({
 *   variables: {
 *      kycGetUploadSignedUrlGetUploadSignedUrlInput: // value for 'kycGetUploadSignedUrlGetUploadSignedUrlInput'
 *   },
 * });
 */
export function useKycGetUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<KycGetUploadSignedUrlQuery, KycGetUploadSignedUrlQueryVariables> & ({ variables: KycGetUploadSignedUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KycGetUploadSignedUrlQuery, KycGetUploadSignedUrlQueryVariables>(KycGetUploadSignedUrlDocument, options);
      }
export function useKycGetUploadSignedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KycGetUploadSignedUrlQuery, KycGetUploadSignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KycGetUploadSignedUrlQuery, KycGetUploadSignedUrlQueryVariables>(KycGetUploadSignedUrlDocument, options);
        }
export function useKycGetUploadSignedUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KycGetUploadSignedUrlQuery, KycGetUploadSignedUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KycGetUploadSignedUrlQuery, KycGetUploadSignedUrlQueryVariables>(KycGetUploadSignedUrlDocument, options);
        }
export type KycGetUploadSignedUrlQueryHookResult = ReturnType<typeof useKycGetUploadSignedUrlQuery>;
export type KycGetUploadSignedUrlLazyQueryHookResult = ReturnType<typeof useKycGetUploadSignedUrlLazyQuery>;
export type KycGetUploadSignedUrlSuspenseQueryHookResult = ReturnType<typeof useKycGetUploadSignedUrlSuspenseQuery>;
export type KycGetUploadSignedUrlQueryResult = Apollo.QueryResult<KycGetUploadSignedUrlQuery, KycGetUploadSignedUrlQueryVariables>;
export const KycGetTemporaryFolderUploadSignedUrlDocument = gql`
    query KycGetTemporaryFolderUploadSignedUrl($getTemporaryFolderUploadSignedUrlInput: GetUploadSignedUrlInput!) {
  kycGetTemporaryFolderUploadSignedUrl(
    GetUploadSignedUrlInput: $getTemporaryFolderUploadSignedUrlInput
  ) {
    signedUrl
    storageObject {
      provider
      bucket
      key
      fileName
    }
  }
}
    `;

/**
 * __useKycGetTemporaryFolderUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useKycGetTemporaryFolderUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useKycGetTemporaryFolderUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKycGetTemporaryFolderUploadSignedUrlQuery({
 *   variables: {
 *      getTemporaryFolderUploadSignedUrlInput: // value for 'getTemporaryFolderUploadSignedUrlInput'
 *   },
 * });
 */
export function useKycGetTemporaryFolderUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<KycGetTemporaryFolderUploadSignedUrlQuery, KycGetTemporaryFolderUploadSignedUrlQueryVariables> & ({ variables: KycGetTemporaryFolderUploadSignedUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KycGetTemporaryFolderUploadSignedUrlQuery, KycGetTemporaryFolderUploadSignedUrlQueryVariables>(KycGetTemporaryFolderUploadSignedUrlDocument, options);
      }
export function useKycGetTemporaryFolderUploadSignedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KycGetTemporaryFolderUploadSignedUrlQuery, KycGetTemporaryFolderUploadSignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KycGetTemporaryFolderUploadSignedUrlQuery, KycGetTemporaryFolderUploadSignedUrlQueryVariables>(KycGetTemporaryFolderUploadSignedUrlDocument, options);
        }
export function useKycGetTemporaryFolderUploadSignedUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KycGetTemporaryFolderUploadSignedUrlQuery, KycGetTemporaryFolderUploadSignedUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KycGetTemporaryFolderUploadSignedUrlQuery, KycGetTemporaryFolderUploadSignedUrlQueryVariables>(KycGetTemporaryFolderUploadSignedUrlDocument, options);
        }
export type KycGetTemporaryFolderUploadSignedUrlQueryHookResult = ReturnType<typeof useKycGetTemporaryFolderUploadSignedUrlQuery>;
export type KycGetTemporaryFolderUploadSignedUrlLazyQueryHookResult = ReturnType<typeof useKycGetTemporaryFolderUploadSignedUrlLazyQuery>;
export type KycGetTemporaryFolderUploadSignedUrlSuspenseQueryHookResult = ReturnType<typeof useKycGetTemporaryFolderUploadSignedUrlSuspenseQuery>;
export type KycGetTemporaryFolderUploadSignedUrlQueryResult = Apollo.QueryResult<KycGetTemporaryFolderUploadSignedUrlQuery, KycGetTemporaryFolderUploadSignedUrlQueryVariables>;
export const KycGetKycInfoByUserIdDocument = gql`
    query KycGetKycInfoByUserId($getKycInfoByUserIdInput: GetKycInfoByUserIdInput!) {
  kycGetKycInfoByUserId(GetKycInfoByUserIdInput: $getKycInfoByUserIdInput) {
    idNumber
    idType
    userId
    email
    status
  }
}
    `;

/**
 * __useKycGetKycInfoByUserIdQuery__
 *
 * To run a query within a React component, call `useKycGetKycInfoByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useKycGetKycInfoByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKycGetKycInfoByUserIdQuery({
 *   variables: {
 *      getKycInfoByUserIdInput: // value for 'getKycInfoByUserIdInput'
 *   },
 * });
 */
export function useKycGetKycInfoByUserIdQuery(baseOptions: Apollo.QueryHookOptions<KycGetKycInfoByUserIdQuery, KycGetKycInfoByUserIdQueryVariables> & ({ variables: KycGetKycInfoByUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KycGetKycInfoByUserIdQuery, KycGetKycInfoByUserIdQueryVariables>(KycGetKycInfoByUserIdDocument, options);
      }
export function useKycGetKycInfoByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KycGetKycInfoByUserIdQuery, KycGetKycInfoByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KycGetKycInfoByUserIdQuery, KycGetKycInfoByUserIdQueryVariables>(KycGetKycInfoByUserIdDocument, options);
        }
export function useKycGetKycInfoByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KycGetKycInfoByUserIdQuery, KycGetKycInfoByUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KycGetKycInfoByUserIdQuery, KycGetKycInfoByUserIdQueryVariables>(KycGetKycInfoByUserIdDocument, options);
        }
export type KycGetKycInfoByUserIdQueryHookResult = ReturnType<typeof useKycGetKycInfoByUserIdQuery>;
export type KycGetKycInfoByUserIdLazyQueryHookResult = ReturnType<typeof useKycGetKycInfoByUserIdLazyQuery>;
export type KycGetKycInfoByUserIdSuspenseQueryHookResult = ReturnType<typeof useKycGetKycInfoByUserIdSuspenseQuery>;
export type KycGetKycInfoByUserIdQueryResult = Apollo.QueryResult<KycGetKycInfoByUserIdQuery, KycGetKycInfoByUserIdQueryVariables>;
export const CluGetUserByTokenDocument = gql`
    query CluGetUserByToken($getUserByTokenInput: GetUserByTokenInput!) {
  cluGetUserByToken(GetUserByTokenInput: $getUserByTokenInput) {
    user {
      id
    }
  }
}
    `;

/**
 * __useCluGetUserByTokenQuery__
 *
 * To run a query within a React component, call `useCluGetUserByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCluGetUserByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCluGetUserByTokenQuery({
 *   variables: {
 *      getUserByTokenInput: // value for 'getUserByTokenInput'
 *   },
 * });
 */
export function useCluGetUserByTokenQuery(baseOptions: Apollo.QueryHookOptions<CluGetUserByTokenQuery, CluGetUserByTokenQueryVariables> & ({ variables: CluGetUserByTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CluGetUserByTokenQuery, CluGetUserByTokenQueryVariables>(CluGetUserByTokenDocument, options);
      }
export function useCluGetUserByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CluGetUserByTokenQuery, CluGetUserByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CluGetUserByTokenQuery, CluGetUserByTokenQueryVariables>(CluGetUserByTokenDocument, options);
        }
export function useCluGetUserByTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CluGetUserByTokenQuery, CluGetUserByTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CluGetUserByTokenQuery, CluGetUserByTokenQueryVariables>(CluGetUserByTokenDocument, options);
        }
export type CluGetUserByTokenQueryHookResult = ReturnType<typeof useCluGetUserByTokenQuery>;
export type CluGetUserByTokenLazyQueryHookResult = ReturnType<typeof useCluGetUserByTokenLazyQuery>;
export type CluGetUserByTokenSuspenseQueryHookResult = ReturnType<typeof useCluGetUserByTokenSuspenseQuery>;
export type CluGetUserByTokenQueryResult = Apollo.QueryResult<CluGetUserByTokenQuery, CluGetUserByTokenQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    